module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-wrapper bg-light"
  }, [_c('flickity', {
    ref: "flickity",
    staticClass: "carousel",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-media"
  }, [_c('hero-video', {
    attrs: {
      "size": '65%',
      "fill": 'cover'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-text"
  })]), _vm._v(" "), _vm._l((_vm.workshops), function(cell, index) {
    return _c('div', {
      key: index,
      staticClass: "carousel-cell"
    }, [_c('div', {
      staticClass: "carousel-media",
      style: ({
        'backgroundImage': 'url(' + cell.productImage.transformedSrc + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-text"
    }, [_c('p', {
      staticClass: "workshop-title",
      domProps: {
        "innerHTML": _vm._s(cell.productTitle)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "workshop-date",
      domProps: {
        "innerHTML": _vm._s(cell.productDate)
      }
    }), _vm._v(" "), (cell.productUrl) ? _c('a', {
      attrs: {
        "href": cell.productUrl
      }
    }, [_vm._v("Details →")]) : _vm._e()])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec9521f","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 222
// module chunks = 1